import React from "react";
import "../../assets/styles/SelectBlockElement.scss";
import classnames from "classnames";
import { SelectBlockOption } from "../../types";

export interface SelectBlockElementProps {
  element: SelectBlockOption;
  index: number;
  toggleAction(index: number): void;
}

export interface SelectBlockElementState {}

export const SelectBlockElement = (props: SelectBlockElementProps) => {
  const { element, index, toggleAction } = props;
  const { name, active } = element;
  return (
    <div className="select-block-element" onClick={() => toggleAction(index)}>
      <div className={classnames("mark", { active })}></div>
      <span>{name}</span>
    </div>
  );
};

export default SelectBlockElement;
